<template>
  <div class="flex flex-direction" id="news">
    <div id="news-pc">
      <div class="top">
        <Title :ch="'热门资讯'"> </Title>
      </div>
      <div class="news_list flex flex-wrap justify-start">
        <div
          class="news_list_box flex flex-direction align-start"
          :style="{
            background:
              hoverIndex == index ? '#ffffff' : 'rgba(255,255,255,.45)',
          }"
          v-for="(item, index) in news"
          :key="index"
          @mouseenter="hoverIndex = index"
          @click="hoverIndex = index"
        >
          <div
            class="title cs"
            @click="lookDetail(item)"
            :style="{ color: hoverIndex == index ? '#B4251E' : '#151E26' }"
          >
            {{ item.title }}
          </div>
          <div class="describe cs" @click="lookDetail(item)">
            {{ item.summaryChange }}
          </div>
          <div class="date">{{ item.date }}</div>
          <div
            class="more flex align-center justify-center cs"
            @click="lookDetail(item)"
          >
            <span>查看详情</span>
            <img :src="rightArrowUrl" />
          </div>
          <div v-if="hoverIndex == index" class="new_hover">
            <img class="topImgUrl" :src="topImgUrl" />
            <img class="bgImgUrl" :src="bgImgUrl" />
          </div>
        </div>
      </div>
      <DidLink @click.native="lookMore"></DidLink>
      <!--      <div class="link flex align-center justify-center cs">-->
      <!--        <span @click="lookMore"> 查看更多 >></span>-->
      <!--      </div>-->
    </div>
    <div id="news-wap">
      <div class="top">
        <Title :ch="'热门资讯'" :bg-img="titleBgImg" />
      </div>
      <div class="list flex">
        <div
          v-if="news.length"
          class="swiper-container-news flex"
          style="width: 100%; height: 100%"
        >
          <div
            class="swiper-wrapper flex"
            style="width: 100%; height: calc(100% - 30px)"
          >
            <div
              class="swiper-slide flex"
              style="
                width: 100%;
                height: 100%;
                transform: translate3d(0, 0, 0);
                overflow: hidden;
              "
              v-for="(item, index) in news"
              :key="index"
            >
              <!--                 @mouseenter="currentVideo = index"
              @click="currentVideo = index"-->
              <div class="slide flex flex-direction justify-between">
                <div class="date">{{ item.date }}</div>
                <div class="title">{{ item.title }}</div>
                <div class="desc">{{ item.summaryChange }}</div>
                <div class="more flex align-center cs">
                  <span>查看详情</span>
                  <img :src="rightArrowUrl" />
                </div>
              </div>
            </div>
          </div>
          <!--     小圆点分页器       -->
          <div
            class="swiper-pagination-news flex align-center justify-center"
            slot="pagination"
            style="width: 100%; height: 20px"
          ></div>
        </div>
      </div>
      <DidLink @click.native="lookMore"></DidLink>
      <!--      <div class="link-new flex align-center justify-center cs">-->
      <!--        <span @click="lookMore"> 查看更多 >></span>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import Title from "./common/Title";
import { Swiper } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { staticApi } from "../services";
var self;
export default {
  name: "News",
  data() {
    return {
      hoverIndex: 0,
      bgImgUrl: require("../assets/images/news/bg.png"),
      topImgUrl: require("../assets/images/news/topImg.png"),
      rightArrowUrl: require("../assets/images/sandbox/rightArrow.png"),
      titleBgImg: require("../assets/images/wap/title/news.png"),
      news: [],
      swiper_news: null,
      swiperOption: {},
    };
  },
  components: {
    Title,
  },
  created() {
    self = this;
    this.getNewsList(); //获取热门资讯列表
  },
  mounted() {
    self = this;
    this.$bus.$on("reSwiper", (res) => {
      //初始化 swiper 方法 ↓
      this.swiper_news.init();
    });
  },
  methods: {
    //获取热门资讯列表
    getNewsList() {
      staticApi
        .request(
          `/${this.$config.tenantId}/seminar/${this.$config.seminarId}/article/list/${this.$config.newsId}.json`
        )
        .then((res) => {
          if (res.result === 0) {
            let newsList = res.content.items;
            for (const item of newsList) {
              item.date = this.formatTime(
                new Date(item.pushTime * 1000),
                "YYYY/MM/DD"
              );
              if (item.showImagesRealPath[0]) {
                item.showImagesRealPath[0] = item.showImagesRealPath[0].replace(
                  /^.*\/\/hwyhw.smarket.net.cn/,
                  "https://hwyhw-files.smarket.net.cn"
                );
              }
              if (item.showImagesRealPath[1]) {
                item.showImagesRealPath[1] = item.showImagesRealPath[1].replace(
                  /^.*\/\/hwyhw.smarket.net.cn/,
                  "https://hwyhw-files.smarket.net.cn"
                );
              }
              if (item.summary.indexOf("^source=") > 1) {
                item.summaryChange = item.summary.substring(
                  0,
                  item.summary.indexOf("^source=")
                );
              } else {
                item.summaryChange = item.summary;
              }
              if (this.$config.articleRelation[item.title]) {
                item.url = this.$config.articleRelation[item.title];
              }
            }
            //筛选
            let newsList1 = newsList.filter((a) => {
              return a.isRecommend == 1;
            });
            //时间排序
            newsList1.sort((a, b) => {
              return a.pushTime - b.pushTime;
            });
            //位置排序
            newsList1.sort((a, b) => {
              return b.order - a.order;
            });
            if (newsList1.length < 6) {
              this.news = newsList1;
              this.$nextTick(() => {
                // 初始化swiper
                this.loadSwiper();
                this.$bus.$emit("ready", "news");
              });
            } else {
              this.news = newsList1.slice(0, 6);
              this.$nextTick(() => {
                // 初始化swiper
                this.loadSwiper();
                this.$bus.$emit("ready", "news");
              });
            }
          }
        })
        .catch((err) => {
          console.error("获取列表失败", err);
        });
    },
    //查看更多 二级列表页
    lookMore() {
      window._hw("send", "action", "index_check_more_all_click", {
        module_name: "热门资讯",
      });
      this.$router.push({
        path: "/news-list",
      });
    },
    //查看详情 外链
    lookDetail(option) {
      //埋码 开发者大会首页-点击社区专题
      window._hw("send", "action", "index_news_btn_click", {
        content_name: option.title, // 内容名称
        product_tag: option.tags[0] ? option.tags[0].name : "", //产品标签
        industry_tag: option.tags[1] ? option.tags[1].name : "", //行业标签
        solution_tag: option.tags[2] ? option.tags[2].name : "", //解决方案标签
        hw_relation: this.$store.state.userInfo.hwRelation, //与华为关系
      });
      //完成任务
      this.$store
        .dispatch("interaction/onCompleteTask", {
          desc: "洞察之眼",
          objectId: option.id,
        })
        .finally(() => {
          window.open(option.url);
        });
    },
    loadSwiper() {
      this.swiper_news = new Swiper(".swiper-container-news", {
        loop: true, //首尾循环
        pagination: {
          el: ".swiper-pagination-news",
          clickable: true,
          bulletClass: "my-bullet",
          bulletActiveClass: "my-bullet-active",
        },
        slidesPerView: "auto",
        centeredSlides: true,
        on: {
          click(e) {
            const realIndex = this.realIndex;
            self.lookDetail(self.news[realIndex]);
          },
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#news-pc {
  display: none;
}
#news-wap {
  display: none;
}

@media screen and (max-width: 992px) {
  #news-wap {
    display: block;
    width: 100%;
    padding-top: 143px;
    padding-bottom: 0px;
    .top {
      width: 100%;
    }
    .list {
      margin: 0 auto;
      width: 100%;
      height: 448px;
      overflow: hidden;
      ::v-deep .swiper-container-news {
        position: relative;
        .swiper-slide {
          width: 80% !important;
          margin: 0 2%;
          height: 100%;
        }
        .swiper-slide-active {
          transition: 200ms;
          transform: scale(1) !important;
        }
        .swiper-slide-prev {
          right: -4%;
          transition: 200ms;
          transform: scale(0.9) !important;
        }
        .swiper-slide-next {
          left: -4%;
          transition: 200ms;
          transform: scale(0.9) !important;
        }
        .swiper-pagination-news {
          width: 100%;
          height: 50px;
          position: absolute;
          left: 0;
          bottom: 0;
          z-index: 10;
        }

        .my-bullet {
          width: 26px;
          height: 8px;
          background: #c4c4c4;
          border-radius: 0px 0px 0px 0px;
          opacity: 1;
          margin: 0 5px;
        }
        .my-bullet-active {
          background: #b4251e;
        }
      }
      .slide {
        padding: 64px 40px 64px 38px;
        position: relative;
        width: 100%;
        height: 100%;
        opacity: 1;
        background: rgba(255, 255, 255, 0.3)
          linear-gradient(
            147deg,
            rgba(255, 255, 255, 0) 0%,
            #ffffff 50%,
            rgba(255, 255, 255, 0) 100%
          );
        opacity: 0.8;
        border: 2px solid;
        border-image: linear-gradient(
            160deg,
            rgba(255, 255, 255, 1),
            rgba(235, 235, 235, 0),
            rgba(235, 235, 235, 0),
            rgba(255, 255, 255, 0.62)
          )
          2 2;
        transform: translate3d(0, 0, 0);
        .date {
          width: 120px;
          height: 30px;
          font-size: 24px;
          font-family: Microsoft YaHei-Light;
          font-weight: 900;
          color: #999999;
          line-height: 30px;
        }
        .title {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          width: 100%;
          height: 76px;
          margin-top: 20px;
          font-size: 28px;
          font-family: Microsoft YaHei-Light;
          font-weight: bold;
          color: #151e26;
          line-height: 36px;
        }
        .desc {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          width: 100%;
          height: 63px;
          // margin-top: 26px;
          font-size: 24px;
          font-family: Microsoft YaHei-Light;
          font-weight: normal;
          color: #888888;
          line-height: 30px;
        }
        .more {
          width: 150px;
          height: 24px;
          font-size: 24px;
          font-family: Microsoft YaHei-Light;
          font-weight: normal;
          color: #b4251e;
          line-height: 24px;
          img {
            margin-left: 5px;
            width: 28px;
            height: 12px;
          }
        }
      }
    }
    .link-new {
      width: 100%;
      height: 30px;
      margin-top: 30px;
      font-size: 12px;
      span {
        height: 30px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;

        color: #b4251e;
        line-height: 30px;
        font-size: 24px;
        border-bottom: 1px solid #b4251e;
        padding-bottom: 1px;
      }
    }
  }
}
@media screen and (min-width: 992px) {
  //news begin
  #news-pc {
    display: block;
    width: 100vw;
    padding-top: 60px;
    padding-bottom: 60px;
    .top {
      margin-left: 160px;
      width: 1158px;
    }
    .news_list {
      margin-top: 4px; //保持和 沙箱实验室 距离标题高度一致
      width: 100%;
      border: 2px solid;
      border-image: linear-gradient(
          160deg,
          rgba(255, 255, 255, 1),
          rgba(235, 235, 235, 0),
          rgba(235, 235, 235, 0),
          rgba(255, 255, 255, 0.62)
        )
        2 2;
      .news_list_box {
        width: 33.3%;
        height: 380px;
        padding-top: 60px;
        padding-left: 75px;
        padding-bottom: 35px;
        background: rgba(255, 255, 255, 0.45);
        border-bottom: 1px solid #ffffff;
        border-right: 1px solid #ffffff;
        filter: blur(undefinedpx);
        position: relative;
        .date {
          width: 132px;
          height: 30px;
          font-size: 18px;
          font-family: Microsoft YaHei-Light;
          font-weight: 400;

          color: #999999;
          line-height: 30px;

          margin-top: 11px;
        }
        .title {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          width: 428px;
          height: 54px;
          font-size: 22px;
          font-family: Microsoft YaHei-Light;
          font-weight: 400;
          color: #151e26;
          line-height: 27px;
        }
        .describe {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          width: 428px;
          height: 48px;
          margin-top: 11px;
          font-size: 18px;
          font-family: Microsoft YaHei-Light;
          font-weight: 400;
          color: #888888;
          line-height: 24px;
        }
        .more {
          height: 24px;
          margin-top: 80px;
          font-size: $font-xxl;
          font-family: Microsoft YaHei-Light;
          font-weight: 400;
          color: #b4251e;
          line-height: 24px;
          span {
            line-height: 1;
          }
          img {
            margin-left: 5px;
            width: 28px;
            height: 12px;
          }
        }
      }

      .new_hover {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        pointer-events: none; //允许穿透
        .topImgUrl {
          width: 100%;
          height: 6px;
          position: absolute;
          top: -2px;
          left: 0;
        }
        .bgImgUrl {
          width: 517px;
          height: 173px;
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }
    }
  }

  //news end
}
</style>
